// Centered card layout for the login screens, with the wordmark above the card.
import Wordmark from './Wordmark.jsx';

export default function AuthLayout({ children }) {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center">
          <Wordmark />
        </div>
        <div className="mt-6 rounded-lg border border-line bg-surface p-8 shadow-md">{children}</div>
      </div>
    </div>
  );
}
